export const _chatMessages = state => state.chat.messages
export const _isMessagesTabOpen = state => state.chat.isMessagesTabOpen
